var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{ref:"cascader",attrs:{"disabled":_vm.disabled,"show-all-levels":false,"options":_vm.orgList,"props":_vm.cascaderProps},on:{"change":_vm.changeOrg},model:{value:(_vm.id),callback:function ($$v) {_vm.id=$$v},expression:"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }